/* eslint-disable no-promise-executor-return */
/* eslint-disable no-restricted-globals */
// src/keycloak.js
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://auth.brunoschillig.com',
  realm: 'neuralboost',
  clientId: 'neuralboost-web',
});

let initPromise = null;
let refreshTimer = null;

function wait(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

export async function initKeycloak() {
  if (initPromise) return initPromise;

  const silentUri = `${window.location.origin}/silent-check-sso.html`;

  // “Plan A”: check-sso con PKCE
  const initCall = keycloak.init({
    onLoad: 'check-sso', // público por /qr/:uuid
    checkLoginIframe: false,
    pkceMethod: 'S256',
    silentCheckSsoRedirectUri: silentUri,
    scope: 'openid profile email',
  });

  // “Plan B”: no nos quedamos colgados si 3p cookies molestan
  initPromise = Promise.race([
    initCall.catch(() => false),
    wait(2000).then(() => 'timeout'), // si tarda, seguimos igual
  ])
    .then(() => {
      // limpia #state/#code en el hash si vuelve así
      if (window.location.hash.includes('code=')) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      // refresco si hay sesión
      if (!refreshTimer) {
        refreshTimer = setInterval(async () => {
          try {
            await keycloak.updateToken(30);
          } catch {
            // si expira, el interceptor de axios mandará a login cuando haga falta
          }
        }, 20_000);
      }

      return keycloak;
    });

  return initPromise;
}

// login preservando la URL actual (muy útil para deep-links)
export function loginWithCurrentUrl() {
  return keycloak.login({ redirectUri: window.location.href });
}

export function isAuthenticated() {
  return !!keycloak.token;
}

// Helpers de roles (cliente de API por defecto)
export function hasRole(role, clientId = 'neuralboost-api') {
  const roles = keycloak.tokenParsed?.resource_access?.[clientId]?.roles || [];
  return roles.includes(role);
}
export function hasAnyRole(roles = [], clientId = 'neuralboost-api') {
  const list = Array.isArray(roles) ? roles : [roles];
  const user = keycloak.tokenParsed?.resource_access?.[clientId]?.roles || [];
  return list.some((r) => user.includes(r));
}

export default keycloak;
